import styled from 'styled-components';
import { getSpacing } from 'stylesheet';
var VideoPreviewContainer = styled.div.withConfig({
  displayName: "VideoBlockstyle__VideoPreviewContainer",
  componentId: "sc-35oq88-0"
})(["display:flex;justify-content:center;width:700px;height:410px;margin:", " auto;"], getSpacing(3));
export { VideoPreviewContainer };